(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teejo-chiffres"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(section) {
    if (section.dataset.numbersDone === 'true') return;
    section.dataset.numbersDone = 'true';
    section.classList.add('is-visible');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    section.querySelectorAll('[data-count]').forEach(function (element) {
      var target = Number(element.dataset.count);
      if (!Number.isFinite(target) || target < 0) return;
      var formatter = new Intl.NumberFormat('fr-FR');
      var start;
      function frame(time) {
        if (start === undefined) start = time;
        var progress = Math.min((time - start) / 1100, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        element.textContent = formatter.format(Math.round(target * eased));
        if (progress < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }
  function init(root) {
    root.querySelectorAll('[data-teejo-numbers]:not([data-numbers-observed])').forEach(function (section) {
      section.dataset.numbersObserved = 'true';
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        reveal(section);
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          reveal(section);
          observer.disconnect();
        }
      }, { threshold: .2 });
      observer.observe(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches('[data-teejo-numbers]')) {
      event.target.removeAttribute('data-numbers-observed');
      init(event.target.parentNode);
    } else init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teejo-duality"] && !Shopify.designMode) return;
  try {
    
function teejoLabInit(root){
  root.querySelectorAll('[data-teejo-cycle]:not([data-ready])').forEach((cycle)=>{
    cycle.dataset.ready='true';
    const plates=[...cycle.querySelectorAll('[data-plate]')], buttons=[...cycle.querySelectorAll('[data-view]')], label=cycle.querySelector('[data-current-label]');
    const labels=[label.textContent.trim(),buttons[1].dataset.label,buttons[2].dataset.label];
    let current=0, timer;
    function show(n){current=n;cycle.dataset.state=String(n);plates.forEach((plate,i)=>plate.classList.toggle('is-current',i===n));buttons.forEach((button,i)=>{button.classList.toggle('is-selected',i===n);button.setAttribute('aria-pressed',String(i===n))});label.textContent=labels[n]}
    function stop(){clearInterval(timer)}
    function start(){stop();if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(()=>show((current+1)%3),3600)}
    buttons.forEach((button,i)=>button.addEventListener('click',()=>{show(i);start()}));
    const observer=new IntersectionObserver((entries)=>{entries[0].isIntersecting?start():stop()},{threshold:.15});observer.observe(cycle);
    document.addEventListener('shopify:section:unload',(event)=>{if(event.target.contains(cycle)){stop();observer.disconnect()}});
  });
  root.querySelectorAll('[data-teejo-lenticular]:not([data-ready])').forEach((lab)=>{
    lab.dataset.ready='true';const tilt=lab.querySelector('[data-tilt]'),label=lab.querySelector('[data-tilt-label]'),buttons=[...lab.querySelectorAll('[data-lenti-view]')];let timer, current=0, interacting=false;
    function set(n){current=n;tilt.classList.toggle('is-alt',n===1);tilt.style.setProperty('--tilt-angle',n===1?'9deg':'-9deg');label.textContent=n===1?'IMAGE 2':'IMAGE 1';buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===n)))}
    function interact(){interacting=true;clearInterval(timer)}
    buttons.forEach((button,i)=>button.addEventListener('click',()=>{interact();set(i)}));
    tilt.addEventListener('pointermove',(event)=>{if(event.pointerType==='touch')return;interact();const rect=tilt.getBoundingClientRect();set(event.clientX-rect.left>rect.width/2?1:0)});
    tilt.addEventListener('keydown',(event)=>{if(event.key==='ArrowLeft'){set(0);event.preventDefault()}if(event.key==='ArrowRight'||event.key==='Enter'||event.key===' '){set(1);event.preventDefault()}});
    const observer=new IntersectionObserver((entries)=>{clearInterval(timer);if(entries[0].isIntersecting&&!interacting&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(()=>set(1-current),3200)},{threshold:.15});observer.observe(lab);
    document.addEventListener('shopify:section:unload',(event)=>{if(event.target.contains(lab)){clearInterval(timer);observer.disconnect()}});
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>teejoLabInit(document));else teejoLabInit(document);
document.addEventListener('shopify:section:load',(event)=>teejoLabInit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teejo-dust"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDust(root) {
    root.querySelectorAll('[data-teejo-dust]').forEach(function (section) {
      if (section.dataset.teejoReady) return;
      section.dataset.teejoReady = 'true';
      var journey = section.querySelector('[data-teejo-dust-journey]');
      var image = section.querySelector('.teejo-dust__new');
      var brush = section.querySelector('.teejo-dust__brush');
      var progress = section.querySelector('.teejo-dust__progress');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var ticking = false;
      function draw() {
        ticking = false;
        if (reduced.matches) return;
        var rect = journey.getBoundingClientRect();
        var distance = Math.max(1, journey.offsetHeight - window.innerHeight);
        var amount = Math.min(1, Math.max(0, -rect.top / distance));
        var edge = -8 + amount * 116;
        image.style.clipPath = 'inset(0 ' + Math.max(0, 100 - edge) + '% 0 0)';
        brush.style.left = edge + '%';
        brush.style.opacity = Math.sin(amount * Math.PI) * .95;
        progress.style.width = amount * 100 + '%';
      }
      function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(draw); } }
      window.addEventListener('scroll', schedule, { passive:true });
      window.addEventListener('resize', schedule);
      draw();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initDust(document); });
  else initDust(document);
  document.addEventListener('shopify:section:load', function (event) { initDust(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teejo-exhibition"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.teejo-exhibition__button[href="#expositions-passees"]');
    if (!link) return;
    var details = document.querySelector('#expositions-passees details');
    if (details) details.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teejo-galeries"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    root.querySelectorAll('[data-teejo-galleries]:not([data-gallery-init])').forEach(function(section){
      section.dataset.galleryInit='true';
      var cards=section.querySelectorAll('.teejo-galleries__card');
      if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches){cards.forEach(function(card){card.classList.add('is-visible');});return;}
      section.classList.add('is-ready');
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});
      },{threshold:.12});
      cards.forEach(function(card){observer.observe(card);});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target.parentNode||document);});
  document.addEventListener('shopify:block:select',function(event){if(event.target.classList.contains('teejo-galleries__card'))event.target.classList.add('is-visible');});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teejo-hero"] && !Shopify.designMode) return;
  try {
    
  function animateTeejoHeroTitle(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('.teejo-hero__title:not([data-letters-ready])').forEach((title) => {
      const original = title.textContent.trim();
      if (!original) return;
      title.dataset.lettersReady = 'true';
      title.setAttribute('aria-label', original);
      const visual = document.createElement('span');
      visual.setAttribute('aria-hidden', 'true');
      let index = 0;
      original.split(/(\s+)/).forEach((part) => {
        if (/^\s+$/.test(part)) {
          visual.append(document.createTextNode(part));
          return;
        }
        const word = document.createElement('span');
        word.className = 'teejo-hero__word';
        for (const character of part) {
          const letter = document.createElement('span');
          letter.className = 'teejo-hero__letter';
          letter.style.setProperty('--letter-index', index++);
          letter.textContent = character;
          word.append(letter);
        }
        visual.append(word);
      });
      title.replaceChildren(visual);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => animateTeejoHeroTitle(document));
  } else {
    animateTeejoHeroTitle(document);
  }
  document.addEventListener('shopify:section:load', (event) => animateTeejoHeroTitle(event.target));

  } catch(e) { console.error(e); }
})();
})();
